export default __webpack_public_path__ + "static/media/D2G.cc357b81.png";